import { render, staticRenderFns } from "./ListExamResults.vue?vue&type=template&id=348b5fae&"
import script from "./ListExamResults.vue?vue&type=script&lang=js&"
export * from "./ListExamResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports